<template>
    <v-container app fluid style="padding:5% 5%;background:#F8F100;">
        <v-row name="menuFooter" justify="center">
          <v-col name="Compradores" cols="6" sm="6" md="2">
            <h4 class="mb-2 menusFooter"><b>{{ $t('SubMenus.ParaCompradores').toUpperCase() }}</b></h4>
            <v-row>
              <v-col cols="12" class="colFooter" v-for="(i, index) in compradores" :key="i.titulo">
                <v-hover v-slot:default="{ hover }">
                  <p @click="ir(index, 'compradores')" class="subtitulosFooter">{{ $t(i.titulo) }}</p>
                </v-hover>
              </v-col>
            </v-row>
          </v-col>
          <v-col name="Artistas" cols="6" sm="6" md="2">
            <h4 class="mb-2 menusFooter"><b>{{ $t('SubMenus.ParaArtistas').toUpperCase() }}</b></h4>
            <v-row>
              <v-col cols="12" class="colFooter" v-for="(i, index) in artistas" :key="i.titulo">
                <v-hover v-slot:default="{ hover }">
                  <p @click="ir(index, 'artistas')" class="subtitulosFooter">{{ $t(i.titulo) }}</p>
                </v-hover>
              </v-col>
            </v-row>
          </v-col>
          <v-col name="AcercaDe" cols="6" sm="6" md="2">
            <h4 class="mb-2 menusFooter"><b>{{ $t('SubMenus.AcercaDe').toUpperCase() }}</b></h4>
            <v-row>
              <v-col cols="12" class="colFooter" v-for="(i, index) in nosotros" :key="i.titulo">
                <v-hover v-slot:default="{ hover }">
                  <p @click="ir(index, 'nosotros')" class="subtitulosFooter">{{ $t(i.titulo) }}</p>
                </v-hover>
              </v-col>
            </v-row>
          </v-col>
          <v-col name="TrArtist" cols="6" sm="6" md="2">
            <h4 class="mb-2 menusFooter"><b>{{ $t('SubMenus.Trartist').toUpperCase() }}</b></h4>
            <v-row>
              <v-col cols="12" class="colFooter" v-for="(i, index) in trartist" :key="i.titulo">
                <v-hover v-slot:default="{ hover }">
                  <p @click="ir(index, 'trartist')" class="subtitulosFooter">{{ $t(i.titulo) }}</p>
                </v-hover>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="center" style="margin-top:40px;">
            <v-btn color="black white--text" @click="setNewsletter(true)">{{ $t('Menu.SubscripcionSletter')}}</v-btn>
          </v-col>
        </v-row>
        <v-row name="RedesSociales" style="margin-top:3%;">
          <v-col class="text-center">
            <v-btn icon color="primary" class="mx-2" v-for="i in redesSociales" :key="i.titulo" :href="i.url" target="_blank">
              <v-icon>{{i.icono}}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="center">
            <span>TrArtist<v-icon color="black" size="14" class="ml-1">far fa-copyright</v-icon> {{$t('Inicio.DerechosReservados')}}</span>
          </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'navegacion-footer',
  data () {
    return {
      compradores: [
        {
          id: 'Asesoria',
          titulo: 'Menu.Asesoria'
        },
        {
          id: 'EnviosYDevoluciones',
          titulo: 'Menu.EnviosYDevoluciones'
        },
        {
          id: 'Faq',
          titulo: 'Menu.Faq'
        },
        {
          id: 'PorQueComprar',
          titulo: 'Menu.PorQueComprar'
        },
        {
          id: 'TarjetaRegalo',
          titulo: 'Menu.TarjetaRegalo'
        }
      ],
      artistas: [
        {
          id: 'PorQueRegistrarse',
          titulo: 'Menu.PorQueRegistrarse'
        },
        {
          id: 'CreativeCommons',
          titulo: 'Menu.CreativeCommons'
        }
      ],
      nosotros: [
        {
          id: 'QuienesSomos',
          titulo: 'Menu.QuienesSomos'
        },
        {
          id: 'Contactanos',
          titulo: 'Menu.Contactanos'
        },
        {
          id: 'Alianzas',
          titulo: 'Menu.Alianzas'
        },
        {
          id: 'TrabajaConNosotros',
          titulo: 'Menu.TrabajaConNosotros'
        }
      ],
      trartist: [
        {
          id: 'PoliticaDePrivacidad',
          titulo: 'Menu.PoliticaDePrivacidad'
        },
        {
          id: 'TyC',
          titulo: 'Menu.TyC'
        }
      ],
      redesSociales: [
        {
          titulo: 'Facebook',
          icono: 'fab fa-facebook-square',
          url: 'https://facebook.com/TrArtistArt/'
        },
        {
          titulo: 'Instagram',
          icono: 'fab fa-instagram',
          url: 'https://instagram.com/trartist_art/'
        },
        {
          titulo: 'Twitter',
          icono: 'fab fa-twitter-square',
          url: 'https://twitter.com/trartist1'
        },
        {
          titulo: 'LinkedIn',
          icono: 'fab fa-linkedin',
          url: 'https://www.linkedin.com/company/trartist/'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['getIdioma'])
  },
  methods: {
    ...mapMutations(['setNewsletter']),
    ir (index, seccion) {
      var alias = null
      if (seccion === 'compradores') {
        alias = `Alias.${this.compradores[index].id}`
      } else if (seccion === 'artistas') {
        alias = `Alias.${this.artistas[index].id}`
      } else if (seccion === 'nosotros') {
        alias = `Alias.${this.nosotros[index].id}`
      } else {
        alias = `Alias.${this.trartist[index].id}`
      }
      const menu = this.$i18n.t(alias)
      this.$router.push(menu)
    }
  }
}
</script>

<style scoped>
.colFooter {
  padding-top:2px;
  padding-bottom:2px;
}
.menusFooter {
  font-size: 13px;
  font-weight: 400 !important;
}
.subtitulosFooter {
  font-size: 13px;
  margin-bottom: 4px;
  color: black;
}
.subtitulosFooter:hover {
  color: #4180FF;
  cursor: pointer;
}
.v-footer {
  padding: 0!important;
}
</style>
